import { css } from '@emotion/css';
import { Show } from 'solid-js';
import { posterDisplayImage } from 'Shared/model/Event';
import { Special } from 'Shared/model/Specials';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';


/* 'contain' rather than 'cover': a special's poster is the shape of the theme it was designed with,
   which need not be the shape of the frame it is shown in - cropping it to fill would cut it off. */
const posterImageStyle = css({
	width: '100%',
	height: '100%',
	objectPosition: 'center',
	objectFit: 'contain'
});


/*
	The best stored rendition of a special's rendered poster, or undefined when there is nothing worth
	showing: no render captured yet, or one that no longer matches the special it was made from.
	Unlike an event there is no fallback poster composed from the record - a special's content lives
	in the design, so an uncaptured poster simply leaves a gap.

	Renders share the Special-image folder with the pictures placed inside a design; assets are named
	by hash, so nothing collides. See Special.assetFolders().
*/
export function specialPosterUrl(special:Special, proxyProductionImages:boolean)
{
	const poster = special.poster;
	if (!poster?.isCurrent || poster.hash==undefined || poster.formats?.medium==undefined)
		return undefined;

	const {size,image} = posterDisplayImage(poster.formats);

	return useUrls().imageUrl('Special-image',false,poster.hash,size,image.format,
		poster.dev ?? false,proxyProductionImages);
}


export function SpecialsPoster(P:{special:Special})
{
	const proxyProductionImages = useProxyProductionImages();

	return (
		<Show when={specialPosterUrl(P.special,proxyProductionImages)}>{url =>
			<img class={posterImageStyle} loading='lazy' alt='' src={url()} />
		}</Show>
	);
}
